import { Injectable } from '@angular/core';
import { AbstractService } from './abstract.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BuscaAvancadaFilter } from '../model/busca-avancada-filter.model';
import { map, Observable } from 'rxjs';
import { ImovelResponseDto } from '../dto/imovel-response.dto';

@Injectable({
   providedIn: 'root'
})
export class BuscaService extends AbstractService {
   constructor(http: HttpClient) {
      super(http);
   }

   fetch(filterParams: BuscaAvancadaFilter): Observable<FetchResponse> {
      if (filterParams.quartos && filterParams.quartos.includes('5')) {
         filterParams['quarto.gte'] = 5;
         filterParams['quarto.lte'] = 100;

         filterParams['quartos'] = undefined;
      }

      Object.keys(filterParams).forEach((key: any) => {
         const keyy = key as keyof BuscaAvancadaFilter;
         const value: any = filterParams[keyy];
         if (value === null || value === undefined || value === '') {
            delete filterParams[keyy];
         }
      });

      let httpParams = new HttpParams({
         fromObject: { ...JSON.parse(JSON.stringify(filterParams)) }
      });

      return this.http.get<FetchResponse>(this.API_REST + '/busca-avancada', {
         params: httpParams
      });
   }

   fetchTips(params: { cidade?: string; contrato?: any; keywords: string }): Observable<string[]> {
      
      if(params.contrato) {
         const contrato = params.contrato === 2 ? 'Compra' : 'Locação'
         params.contrato = contrato;
      }

      
      let httpParams = new HttpParams({
         fromObject: { ...JSON.parse(JSON.stringify(params)) }
      });
      return this.http
         .get<{ data: string[] }>(this.API_REST + '/busca-avancada-tips', { params: httpParams })
         .pipe(map((response) => response.data));
   }
}

export interface FetchResponse {
   items: ImovelResponseDto[];
   page: number;
   pageSize: number;
   total: number;
   totalPages: number;
}
